// MUI Theme
import { Tooltip } from '@mui/material';
import { Article } from '@mui/icons-material';

// Types
import { CollectionItemTypes, CollectionMethod } from '../../types/CollectionItemTypes';
import { AppPermissions } from '../../constants/Permissions';

// Services
import AuthService from '../../services/auth.service';

// Utils
import { dateHeader, formatCellDate } from './timeModeCell';

export const makeCollectionListColumn = (onInfoClick) => {
  const col = [
    {
      header: 'Id',
      accessorKey: 'id',
      headerClassName: 'react-table-header-align-center',
      sortable: false,
      enableColumnFilter: false,
      size: 50,
      style: { textAlign: 'center' },
      cell: ({ row }) => {
        return (
          <>
            {AuthService.hasPermission(AppPermissions.Collections.Read) ? (
              <Tooltip title='View Items' placement='right' style={{ cursor: 'pointer' }}>
                <Article style={{ height: '0.7em' }} color='action' cursor='pointer' onClick={(e) => onInfoClick(e, row.original)} />
              </Tooltip>
            ) : null}
          </>
        );
      },
    },
    {
      header: 'Name',
      accessorKey: 'name',
      enableColumnFilter: true,
      size: 180,
    },
    {
      header: 'Station',
      accessorKey: 'targetedStation.iataCode',
      sortable: false,
      enableColumnFilter: true,
      size: 180,
      cell: ({ row }) => {
        const targetedStation = row.original.targetedStation?.iataCode;

        return targetedStation && targetedStation;
      },
    },
    {
      header: 'Items Count',
      accessorKey: 'count',
      enableColumnFilter: true,
      size: 80,
    },
    {
      header: 'Item Types',
      accessorKey: 'collect',
      enableColumnFilter: false,
      size: 330,
      cell: ({ row }) => {
        const collectItems = row.original.configuration.collect;

        const collectNames = collectItems && collectItems.length > 0 ? collectItems.map((item: number) => CollectionItemTypes[item]).join(' | ') : '';

        return collectNames;
      },
    },
    {
      header: 'Collection Method',
      sortable: false,
      enableColumnFilter: false,
      size: 240,
      cell: ({ row }) => {
        const collectMethods = row.original.configuration.methods;

        const collectMethod =
          collectMethods && collectMethods.length > 0 ? collectMethods.map((item: number) => CollectionMethod[item]).join(' | ') : '';

        return collectMethod;
      },
    },
    {
      header: 'User Name',
      accessorKey: 'originalAuthorUserName',
      size: 110,
    },
    {
      header: dateHeader('Created'),
      accessorKey: 'createdDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.createdDateTime),
    },
    {
      header: dateHeader('Modified'),
      accessorKey: 'modifiedDateTime',
      size: 110,
      cell: ({ row, table }) => formatCellDate(table, row.original.modifiedDateTime),
    },
  ] as Array<any>;

  return col;
};
